module.exports = __webpack_public_path__ + "static/media/LoanLogik.50b79035.png";